import IntlTelInput from 'intl-tel-input';

class CustomerDetail {
  constructor() {
    this._setup();
  }

  _setup() {
    this.telInput = document.querySelector('#booking_phone_number');
    this.dialCodeInput = document.querySelector('#booking_dial_code');
    if (!this.telInput) { return; }

    this.iti = IntlTelInput(this.telInput, {
      initialCountry: 'th',
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.0/js/utils.js'
    });

    const submit = document.querySelector('#formBookingSession__submit');
    if (submit) {
      submit.addEventListener('click', (event) => this.clickHandler(event));
    }

    // Clear validation error when user types
    this.telInput.addEventListener('input', () => {
      this.telInput.setCustomValidity('');
    });
  }

  clickHandler(event) {
    if (this.telInput.value.trim() !== '') {
      if (!this.iti.isValidNumber()) {
        event.preventDefault();
        this.telInput.setCustomValidity('Please enter a valid phone number.');
        this.telInput.reportValidity();
        return;
      }
      this.telInput.setCustomValidity('');

      const dialCode = this.iti.getSelectedCountryData().dialCode;
      this.telInput.value = `0${this.iti.getNumber().replace(`+${dialCode}`, '')}`;
      if (this.dialCodeInput) {
        this.dialCodeInput.value = dialCode;
      }
    }
  }
}

if (document.querySelector('#booking_phone_number')) {
  new CustomerDetail();
}
